import { AppState } from '..';
import { Code } from './code.types';

export const genderCodeSelector = (state: AppState): Code[] =>
  state.genderCodes.code!;
